import Cookies from "js-cookie";
import { cookieDomain, cookieSameSite, cookieSecure } from "./constants";

export type ThemePreferenceMode = "light" | "dark" | "auto";
export type ResolvedThemeMode = "light" | "dark";

export const THEME_STORAGE_KEY = "pd.id.express.personal-data.theme";
export const THEME_COOKIE_KEY = "pd_idexpress_theme";
export const THEME_PREFERENCE_CHANGE_EVENT = "pd:idexpress-theme-preference-change";

const cookieOptions = {
  expires: 365,
  sameSite: cookieSameSite,
  secure: cookieSecure,
  domain: cookieDomain,
};

export const normalizeThemePreference = (theme?: string | null): ThemePreferenceMode | "" => {
  if (theme === "light" || theme === "dark" || theme === "auto") return theme;
  if (theme === "system") return "auto";
  return "";
};

export const resolveThemePreference = (theme: ThemePreferenceMode): ResolvedThemeMode => {
  if (theme === "light" || theme === "dark") return theme;

  const hour = new Date().getHours();
  return hour >= 7 && hour < 19 ? "light" : "dark";
};

export const getStoredThemePreference = (): ThemePreferenceMode | "" => {
  if (typeof window === "undefined") return "";

  const storedTheme = normalizeThemePreference(localStorage.getItem(THEME_STORAGE_KEY));
  if (storedTheme) return storedTheme;

  return normalizeThemePreference(Cookies.get(THEME_COOKIE_KEY));
};

export const getInitialThemePreference = (): ThemePreferenceMode =>
  getStoredThemePreference() || "auto";

export const persistThemePreference = (theme: string) => {
  const normalized = normalizeThemePreference(theme);
  if (!normalized || typeof window === "undefined") return "";

  localStorage.setItem(THEME_STORAGE_KEY, normalized);
  Cookies.set(THEME_COOKIE_KEY, normalized, cookieOptions);

  return normalized;
};
